/* The Detail Reserve — Lead Detailer application (five steps).
   Answers live only in this page's form: nothing is saved in the browser, and analytics get step
   counts only. "Received" is shown only after the private intake confirms it stored the application. */
(() => {
  const form = document.querySelector('[data-ap]');
  if (!form) return;
  const $ = (s, r = form) => r.querySelector(s);
  const $$ = (s, r = form) => [...r.querySelectorAll(s)];
  const spec = JSON.parse($('[data-ap-spec]').textContent);
  const steps = $$('[data-ap-step]');
  const dots = $$('[data-ap-dot]');
  const back = $('[data-ap-back]');
  const next = $('[data-ap-next]');
  const toReview = $('[data-ap-to-review]');
  const submit = $('[data-ap-submit]');
  const errBox = $('[data-ap-errors]');
  const ok = document.querySelector('[data-ap-ok]');
  const started = Date.now();
  // One key per application: a retried send is recognised by the intake instead of stored twice.
  const key = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`);
  const track = (name, params) => window.tdrTrack && window.tdrTrack(name, params); // no answers, ever
  let cur = 0;
  let reviewed = false;
  let dirty = false;
  let sent = false;

  const fieldsOf = (i) => spec.steps[i].fields.flatMap((f) => (f.type === 'matrix' ? f.rows.map((r) => ({ ...r, type: 'level', required: f.required && !r.optional, options: f.levels })) : [f]));
  const value = (f) => {
    if (f.type === 'radio' || f.type === 'level') return form.querySelector(`input[name="${f.name}"]:checked`)?.value || '';
    if (f.type === 'check') return Boolean(form.elements[f.name]?.checked);
    return (form.elements[f.name]?.value || '').trim();
  };

  const show = (i) => {
    cur = i;
    steps.forEach((s, n) => { s.hidden = n !== i; });
    dots.forEach((d, n) => { d.classList.toggle('is-done', n < i); d.classList.toggle('is-on', n === i); if (n === i) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current'); });
    back.hidden = i === 0;
    next.hidden = i === steps.length - 1;
    submit.hidden = i !== steps.length - 1;
    toReview.hidden = !(reviewed && i < steps.length - 1);
    if (i === steps.length - 1) { reviewed = true; renderReview(); }
    errBox.hidden = true;
    form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    track('job_application_step', { step: i + 1 });
  };

  const setError = (name, msg) => {
    const wrap = form.querySelector(`[data-f="${name}"]`);
    if (!wrap) return null;
    const id = `ap-${name}-err`;
    let m = document.getElementById(id);
    if (!m) { m = document.createElement('span'); m.className = 'field-error'; m.id = id; wrap.append(m); }
    m.textContent = msg;
    const target = wrap.querySelector('input, textarea, select') || wrap;
    $$('input, textarea, select', wrap).forEach((el) => { el.setAttribute('aria-invalid', 'true'); const d = (el.getAttribute('aria-describedby') || '').split(' ').filter((x) => x && x !== id); d.push(id); el.setAttribute('aria-describedby', d.join(' ')); });
    return target;
  };
  const clearErrors = (scope) => {
    $$('.field-error', scope).forEach((m) => m.remove());
    $$('[aria-invalid]', scope).forEach((el) => el.removeAttribute('aria-invalid'));
  };

  const check = (i) => {
    const scope = steps[i];
    clearErrors(scope);
    const bad = [];
    fieldsOf(i).forEach((f) => {
      const v = value(f);
      let msg = '';
      if (f.required && (v === '' || v === false)) msg = f.type === 'check' ? 'Please tick this to continue' : 'Required';
      else if (v && f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(v)) msg = 'Check the email address';
      else if (v && f.type === 'tel' && !/^[0-9+().\- ]{7,30}$/.test(v)) msg = 'Check the phone number';
      else if (v && f.type === 'url' && !/^https?:\/\/\S+$/i.test(v)) msg = 'Start the link with https://';
      else if (f.max && typeof v === 'string' && v.length > f.max) msg = `Please keep this under ${f.max} characters`;
      if (msg) bad.push(setError(f.name, msg));
    });
    if (spec.steps[i].key === 'contact' && !value({ name: 'start', type: 'date' }) && !value({ name: 'start_flexible', type: 'check' })) bad.push(setError('start', 'Give a start date or tick "flexible"'));
    if (bad.length) {
      errBox.hidden = false;
      errBox.textContent = `Please check ${bad.length === 1 ? '1 answer' : `${bad.length} answers`} on this step.`;
      bad[0]?.focus();
    }
    return !bad.length;
  };

  // Review: every answer, grouped by step, each group with an Edit button.
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const renderReview = () => {
    const box = $('[data-ap-review]');
    box.innerHTML = spec.steps.slice(0, -1).map((st, i) => {
      const rows = fieldsOf(i).map((f) => { const v = value(f); const shown = v === true ? 'Yes' : v === false || v === '' ? '—' : v; return `<div><dt>${esc(f.label)}</dt><dd>${esc(shown)}</dd></div>`; }).join('');
      return `<section class="ap__rv"><div class="ap__rv-h"><h4>${esc(st.title)}</h4><button type="button" class="link" data-ap-edit="${i}">Edit<span class="sr-only"> ${esc(st.title)}</span></button></div><dl>${rows}</dl></section>`;
    }).join('');
  };

  next.addEventListener('click', () => { if (check(cur)) show(cur + 1); });
  back.addEventListener('click', () => show(cur - 1));
  toReview.addEventListener('click', () => { if (check(cur)) show(steps.length - 1); });
  form.addEventListener('click', (e) => { const ed = e.target.closest('[data-ap-edit]'); if (ed) { show(Number(ed.dataset.apEdit)); $('input:not([type="hidden"]), textarea', steps[cur])?.focus({ preventScroll: true }); } });
  form.addEventListener('input', () => { dirty = true; });
  // Enter in a text box moves on instead of submitting half an application.
  form.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.matches('input:not([type="checkbox"]):not([type="radio"])') && cur < steps.length - 1) { e.preventDefault(); next.click(); } });
  window.addEventListener('beforeunload', (e) => { if (dirty && !sent) { e.preventDefault(); e.returnValue = ''; } });

  // The send button isn't a native submit, so no browser "form submitted" event (which Shopify's
  // customer-events system relays to pixels) ever carries these answers.
  form.addEventListener('submit', (e) => e.preventDefault());
  submit.addEventListener('click', async () => {
    if (!check(cur) || submit.disabled) return;
    const fields = {};
    spec.steps.forEach((_, i) => fieldsOf(i).forEach((f) => { fields[f.name] = value(f); }));
    submit.disabled = true; submit.textContent = 'Sending…';
    errBox.hidden = true;
    try {
      // text/plain keeps this a simple request the intake can answer without a CORS preflight.
      const res = await fetch(form.dataset.endpoint, { method: 'POST', body: JSON.stringify({ submission_key: key, elapsed_ms: Date.now() - started, posting: spec.posting, company_website: form.elements.company_website.value, fields }) });
      const out = await res.json();
      if (out.ok && out.id) {
        sent = true;
        form.hidden = true; ok.hidden = false;
        ok.querySelector('[data-ap-id]').textContent = out.id;
        ok.focus();
        track('job_application_submit', { step: steps.length });
        return;
      }
      if (out.error === 'validation' && Array.isArray(out.fields)) {
        const i = spec.steps.findIndex((st, n) => fieldsOf(n).some((f) => out.fields.includes(f.name)));
        if (i > -1) { show(i); out.fields.forEach((n) => setError(n === 'start' ? 'start' : n, 'Please check this answer')); errBox.hidden = false; errBox.textContent = 'Some answers need another look.'; return; }
      }
      throw new Error(out.error || 'not stored');
    } catch (_) {
      errBox.hidden = false;
      errBox.textContent = `We couldn't confirm your application was received. Your answers are still here, so please try again in a moment. If it keeps happening, email ${document.querySelector('.ap__access a')?.textContent || 'us'}.`;
      errBox.focus?.();
    } finally {
      submit.disabled = false; submit.textContent = 'Submit application';
    }
  });

  errBox.tabIndex = -1;
  steps.forEach((s, i) => { s.hidden = i !== 0; });
  dots.forEach((d, n) => d.classList.toggle('is-on', n === 0));
  dots[0]?.setAttribute('aria-current', 'step');
  back.hidden = true;
})();
